/**
 * ハイコントラストカラープリセット
 * 背景との明度差を大きくし、視認性を高める
 */

import type { ColorPreset } from './types';

export const HIGH_CONTRAST_PRESET: ColorPreset = {
  base: {
    WHITE: '#ffffff',
    BLACK: '#000000',
    GRAY: '#595959',
    LIGHT_GRAY: '#f5f5f5',
    BORDER: '#8c8c8c',
    TEXT: '#000000',
    TEXT_SECONDARY: 'rgba(0, 0, 0, 0.75)',
  },
  theme: {
    PRIMARY: '#0050b3',
    PRIMARY_DARK: '#003a8c',
    SUCCESS: '#237804',
    WARNING: '#ad6800',
    ERROR: '#910d0d',
    INFO: '#0050b3',
  },
  darkTheme: {
    BACKGROUND: '#000000',
    BORDER: '#001529',
    TEXT: '#ffffff',
  },
  status: {
    ACTIVE: '#237804',
    STOPPED: '#595959',
    WARNING: '#ad6800',
    ERROR: '#910d0d',
  },
  chart: {
    SERIES_1: '#910d0d',
    SERIES_2: '#0050b3',
    SERIES_3: '#237804',
    SERIES_4: '#ad6800',
    SERIES_5: '#531dab',
    SERIES_6: '#006d75',
    SERIES_7: '#c41d7f',
    SERIES_8: '#821414',
    SERIES_9: '#ad4e00',
    NO_DATA_MASK: 'rgba(0, 0, 0, 0.15)',
  },
  logLevel: {
    INFO: '#0050b3',
    WARNING: '#ad6800',
    ERROR: '#910d0d',
  },
  statistic: {
    TOTAL: '#0050b3',
    ACTIVE: '#237804',
    INACTIVE: '#595959',
    WARNING: '#ad6800',
  },
  feedbackBackground: {
    ERROR_BG: '#ffccc7',
    ERROR_LIGHT: '#fff1f0',
    SUCCESS_LIGHT: '#f6ffed',
  },
} as const;
